import React, { memo, useEffect, useMemo, useState } from 'react';

import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { SearchFilterConfigurationStatus } from 'constants/programs';

import ProgramsAndPricing from './components/ProgramsAndPricing';

const LoanInfoModal = ({
  atParPayloadRef,
  isLoading,
  onSelectProgram,
  canSelectProgram,
  isFromPropertyAndLoan = false,
  isProgramReselection = false,
  setTempRateSheetId,
  rateSheetId,
  pendingChanges,
  getLoanOptions,
  searchFilterConfigurationStatus,
}) => {
  const [selectedLoanProgramOption, setSelectedLoanProgramOption] = useState(null);

  useEffect(() => {
    if (!selectedLoanProgramOption || !onSelectProgram) {
      return;
    }

    onSelectProgram(selectedLoanProgramOption);
  }, [selectedLoanProgramOption, onSelectProgram]);

  const additionalProps = useMemo(
    () => ({
      selectedLoanProgramOption,
      setSelectedLoanProgramOption,
    }),
    [selectedLoanProgramOption],
  );

  return (
    <ProgramsAndPricing
      additionalProps={additionalProps}
      atParPayloadRef={atParPayloadRef}
      canSelectProgram={canSelectProgram}
      getLoanOptions={getLoanOptions}
      isFromPropertyAndLoan={isFromPropertyAndLoan}
      isLoading={isLoading}
      isProgramReselection={isProgramReselection}
      pendingChanges={pendingChanges}
      rateSheetId={rateSheetId}
      searchFilterConfigurationStatus={searchFilterConfigurationStatus}
      setTempRateSheetId={setTempRateSheetId}
    />
  );
};

LoanInfoModal.propTypes = {
  getLoanOptions: PropTypes.func.isRequired,
  atParPayloadRef: PropTypes.shape({ current: PropTypes.object }),
  canSelectProgram: PropTypes.func,
  isFromPropertyAndLoan: PropTypes.bool,
  isProgramReselection: PropTypes.bool,
  searchFilterConfigurationStatus: PropTypes.oneOf(Object.values(SearchFilterConfigurationStatus)),
  setTempRateSheetId: PropTypes.func,
  onSelectProgram: PropTypes.func,
  ...WithLoadingPropTypes,
};

export default memo(LoanInfoModal);
